import { render, staticRenderFns } from "./Tsocial.vue?vue&type=template&id=18d94b2d&"
import script from "./Tsocial.vue?vue&type=script&lang=js&"
export * from "./Tsocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports